import { Toolbar, alpha, Typography, TextField, InputAdornment, Icon, Tooltip, IconButton, Box } from "@mui/material";
import AutocompleteEmpresas from "@/components/AutocompleteEmpresas";
import DeleteIcon from "@mui/icons-material/Delete";

export interface EnhancedTableToolbarProps {
    numSelected: number;
    loading: boolean;
    searchValue?: string;
    onChangeSearchValue?: (value: string) => void;
    empresas: IEmpresa[];
    empresaSelected: IEmpresa | null;
    setEmpresaSelected: (empresa: IEmpresa | null) => void;
    hideSearchCompany?: boolean;
}

function EnhancedTableToolbar(props: EnhancedTableToolbarProps) {
    const { numSelected,
        searchValue, onChangeSearchValue,
        empresas, empresaSelected, setEmpresaSelected,
        hideSearchCompany
    } = props;

    return (
        <Toolbar
            sx={{
                py: 2,
                pl: { sm: 2 },
                pr: { xs: 1, sm: 1 },
                ...(numSelected > 0 && {
                    bgcolor: (theme) =>
                        alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
                }),
            }}
        >
            {numSelected > 0 ? (
                <Typography
                    sx={{ flex: '1 1 100%' }}
                    color="inherit"
                    variant="subtitle1"
                    component="div"
                >
                    {numSelected} selected
                </Typography>
            ) : (
                <Box sx={{ display: 'inline-flex', gap: '1rem', flexDirection: { xs: 'column', sm: 'row' }, width: '100%' }}>
                    {!hideSearchCompany && <AutocompleteEmpresas
                        rows={empresas || []}
                        loading={false}
                        empresa={empresaSelected}
                        onChange={(empresa) => setEmpresaSelected(empresa)} />
                    }
                    <TextField
                        fullWidth
                        label="Buscá un usuario..."
                        variant="outlined"
                        value={searchValue}
                        InputProps={{
                            startAdornment: <InputAdornment position="start"><Icon>search</Icon></InputAdornment>,
                        }}
                        onChange={(e) => onChangeSearchValue && onChangeSearchValue(e.target.value)}
                    />

                </Box>
            )}
            {numSelected > 0 ? (
                <Tooltip title="Delete">
                    <IconButton>
                        <DeleteIcon />
                    </IconButton>
                </Tooltip>
            ) : (
                <></>
            )}
        </Toolbar>
    );
}
export default EnhancedTableToolbar;